module.exports = __webpack_public_path__ + "static/img/8.dfaab5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/8.png
// module id = YmLv
// module chunks = 0